function firstString(list) {
  if (!Array.isArray(list)) {
    return null;
  }
  return list.find((item) => typeof item === 'string') ?? null;
}

export default function formatRubricSaveError(err) {
  const errors = err?.response?.data?.errors;

  if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
    const nameMessage = firstString(errors.name);
    if (nameMessage) {
      return `Rubric name ${nameMessage}.`;
    }

    const detail = errors.detail;
    if (typeof detail === 'string' && detail.trim()) {
      return detail;
    }
  }

  const fallback =
    err?.response?.data?.error || err?.message || 'Could not save rubric.';
  return typeof fallback === 'string'
    ? fallback
    : JSON.stringify(fallback, null, 2);
}
